module.exports = "/_next/static/files/05c976b5282d0fe794fe5d138238abaa.png";